import {filter, isNil, isEmpty, keys, map} from 'ramda';

export const isNilOrEmpty = (...args) =>
    filter(val => !isNil(val) && !isEmpty(val), args).length <= 0;

export const convertHashmapToArray = (hashmap = {}) =>
    isNilOrEmpty(hashmap) ? [] : map(key => hashmap[key], keys(hashmap));
